var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _path9, _path0, _ellipse2, _path1, _path10, _path11, _path12, _ellipse3, _path13, _path14, _path15, _path16, _rect, _path17, _path18, _rect2, _path19, _path20, _rect3, _path21, _path22, _rect4, _path23, _path24, _rect5, _path25, _path26, _rect6, _path27, _path28, _rect7, _path29, _path30, _rect8, _path31, _path32, _rect9, _path33, _ellipse4, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterHandsUp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 147,
    viewBox: "0 0 173 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9686 136.673C74.9688 142.185 75.6239 146.652 72.8775 146.652C70.033 146.652 67.1935 140.564 67.1932 135.054C67.1933 129.541 71.7236 126.695 72.8781 126.695C74.0326 126.695 74.9691 131.164 74.9686 136.673Z",
    fill: "#FF9B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8299 136.674C97.8305 142.185 97.1764 146.653 99.9228 146.654C102.768 146.653 105.608 140.565 105.608 135.055C105.608 129.542 101.078 126.697 99.9223 126.697C98.7678 126.697 97.8297 131.165 97.8299 136.674Z",
    fill: "#FF9B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.514 49.1976C136.96 26.2019 141.716 7.67762 147.08 7.197C152.629 6.70361 149.946 31.6211 142.498 54.6184C135.054 77.6121 122.37 90.2748 120.115 90.4769C117.859 90.6752 122.07 72.1909 129.514 49.1976Z",
    fill: "#FF9B2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9397 49.1976C35.4939 26.2019 30.738 7.67762 25.3742 7.197C19.825 6.70361 22.5076 31.6211 29.9564 54.6184C37.4001 77.6121 50.0842 90.2748 52.3386 90.4769C54.595 90.6752 50.3844 72.1909 42.9397 49.1976Z",
    fill: "#FF9B2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.549 109.631C130.549 132.035 112.381 136.674 89.9692 136.674H83.2087C60.7967 136.674 42.6299 132.035 42.6299 109.631V62.3068C42.6299 39.9026 60.7967 21.7393 83.2087 21.7393H89.9692C112.381 21.7393 130.549 39.9026 130.549 62.3068V109.631Z",
    fill: "#FF9B2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M126.607 77.9687C126.607 79.5459 126.551 101.338 126.434 102.774C124.699 124.348 110.082 130.458 86.4002 130.458C62.5734 130.458 47.9253 124.275 46.3348 102.385C46.2389 101.065 46.1899 79.4043 46.1899 77.9687C46.1899 52.7136 61.1373 32.2402 86.4002 32.2402C111.663 32.2402 126.607 52.7136 126.607 77.9687Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 86.325,
    cy: 76.9303,
    rx: 43.325,
    ry: 28.9,
    fill: "url(#paint0_radial_14011_164659)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.559 55.8592C116.559 64.2864 109.723 71.1162 101.296 71.1162C92.8665 71.1162 86.0336 64.2864 86.0336 55.8592C86.0336 47.433 92.8665 40.6022 101.296 40.6022C109.723 40.6022 116.559 47.433 116.559 55.8592Z",
    fill: "#FF9B2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.642 55.8593C113.642 62.676 108.115 68.202 101.296 68.202C94.4773 68.202 88.9496 62.676 88.9496 55.8593C88.9496 49.0426 94.4773 43.5166 101.296 43.5166C108.115 43.5166 113.642 49.0426 113.642 55.8593Z",
    fill: "url(#paint1_radial_14011_164659)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.936 55.8601C107.936 59.5269 104.963 62.4995 101.295 62.4995C97.6268 62.4995 94.6533 59.5269 94.6533 55.8601C94.6533 52.1933 97.6268 49.2207 101.295 49.2207C104.963 49.2207 107.936 52.1933 107.936 55.8601Z",
    fill: "url(#paint2_radial_14011_164659)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M104.401 55.8593C104.401 57.574 103.01 58.9648 101.296 58.9648C99.5798 58.9648 98.1885 57.574 98.1885 55.8593C98.1885 54.1447 99.5798 52.7538 101.296 52.7538C103.01 52.7538 104.401 54.1447 104.401 55.8593Z",
    fill: "#2E2A49"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.3,
    cy: 52.5825,
    rx: 3.7,
    ry: 2.84251,
    fill: "url(#paint3_linear_14011_164659)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1421 55.4197C87.1421 63.847 80.3102 70.6768 71.8804 70.6768C63.4517 70.6768 56.6166 63.847 56.6166 55.4197C56.6166 46.9925 63.4517 40.1627 71.8804 40.1627C80.3102 40.1627 87.1421 46.9925 87.1421 55.4197Z",
    fill: "#FF9B2E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2261 55.4198C84.2261 62.2365 78.6984 67.7625 71.8796 67.7625C65.0609 67.7625 59.5332 62.2365 59.5332 55.4198C59.5332 48.6032 65.0609 43.0771 71.8796 43.0771C78.6984 43.0771 84.2261 48.6032 84.2261 55.4198Z",
    fill: "url(#paint4_radial_14011_164659)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5226 55.4197C78.5226 59.0871 75.5487 62.0601 71.8802 62.0601C68.2117 62.0601 65.2378 59.0871 65.2378 55.4197C65.2378 51.7523 68.2117 48.7793 71.8802 48.7793C75.5487 48.7793 78.5226 51.7523 78.5226 55.4197Z",
    fill: "url(#paint5_radial_14011_164659)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 55.4198C74.9883 57.1355 73.5949 58.5264 71.8808 58.5264C70.1635 58.5264 68.7733 57.1355 68.7733 55.4198C68.7733 53.7052 70.1635 52.3132 71.8808 52.3132C73.5949 52.3132 74.9883 53.7052 74.9883 55.4198Z",
    fill: "#2E2A49"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.8802,
    cy: 52.1423,
    rx: 3.7,
    ry: 2.84251,
    fill: "url(#paint6_linear_14011_164659)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4972 76.621C65.8972 76.621 49.6938 72.8371 42.4891 69.508C46.1591 72.8307 63.3437 77.9682 86.4972 77.9682C109.472 77.9682 126.902 72.7924 130.534 69.4707C123.296 72.8084 106.937 76.621 86.4972 76.621Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4974 76.4444C65.8974 76.4444 49.694 72.6594 42.4893 69.3302C46.1593 72.653 63.3438 77.7894 86.4974 77.7894C109.472 77.7894 126.903 72.6157 130.534 69.293C123.296 72.6317 106.938 76.4444 86.4974 76.4444Z",
    fill: "#6D0F0F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.332 76.4229V78.5326C83.332 80.4432 84.881 81.9917 86.7911 81.9917C88.7023 81.9917 90.2512 80.4432 90.2512 78.5326V76.4229H83.332Z",
    fill: "#EDDD9A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8735 76.4229V78.2024C83.8735 79.8138 85.1785 81.1194 86.7904 81.1194C88.4011 81.1194 89.7082 79.8138 89.7082 78.2024V76.4229H83.8735Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 6.9192,
    height: 2.03732,
    transform: "matrix(1 0 0 -1 83.332 78.4602)",
    fill: "#E66D28"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2153 76.3725C91.2164 76.3821 91.2153 76.3906 91.2164 76.3981L91.3634 79.2459C91.4998 81.8455 93.7156 83.8445 96.3182 83.7092C98.9186 83.575 100.918 81.3567 100.782 78.7581L100.635 75.9103C100.634 75.9018 100.634 75.8922 100.634 75.8848L91.2153 76.3725Z",
    fill: "#EDDD9A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9541 76.336V76.3562L92.0787 78.7578C92.1917 80.9506 94.0624 82.6354 96.2558 82.5225C98.4482 82.4085 100.134 80.5384 100.021 78.3467L99.896 75.9451C99.896 75.9377 99.896 75.9302 99.8939 75.9238L91.9541 76.336Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 9.43117,
    height: 2.77652,
    transform: "matrix(-0.998662 0.051719 0.0517503 0.99866 100.633 75.8848)",
    fill: "#E66D28"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101.608 75.7385V75.7545L101.805 77.4255C101.985 78.9505 103.367 80.0432 104.892 79.8632C106.421 79.6843 107.511 78.3009 107.332 76.7747L107.136 75.1038C107.136 75.0985 107.134 75.0942 107.133 75.0889L101.608 75.7385Z",
    fill: "#EDDD9A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M102.041 75.6881V75.7009L102.207 77.1099C102.359 78.3964 103.524 79.3176 104.812 79.1653C106.099 79.0151 107.019 77.849 106.867 76.5614L106.704 75.1524C106.702 75.1492 106.702 75.1439 106.699 75.1396L102.041 75.6881Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 5.56406,
    height: 1.63913,
    transform: "matrix(-0.99314 0.116928 0.116998 0.993132 107.134 75.0879)",
    fill: "#E66D28"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.409 74.9575C108.411 74.9639 108.413 74.9703 108.413 74.9777L108.803 77.1897C109.158 79.21 111.085 80.5593 113.107 80.2036C115.128 79.8479 116.475 77.9224 116.12 75.9021L115.731 73.6891C115.731 73.6827 115.728 73.6774 115.726 73.6699L108.409 74.9575Z",
    fill: "#EDDD9A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M108.982 74.8568C108.985 74.8611 108.985 74.8674 108.986 74.8728L109.314 76.7386C109.614 78.4426 111.238 79.58 112.942 79.2797C114.647 78.9804 115.784 77.3574 115.486 75.6523L115.156 73.7875C115.154 73.7822 115.154 73.7758 115.153 73.7705L108.982 74.8568Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 7.43144,
    height: 2.18662,
    transform: "matrix(-0.984895 0.173154 0.173256 0.984877 115.727 73.6702)",
    fill: "#E66D28"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M118.003 73.1934C118.005 73.1987 118.007 73.2051 118.007 73.2115L118.517 75.2414C118.982 77.0945 120.861 78.2191 122.714 77.7526C124.57 77.2883 125.692 75.4086 125.229 73.5566L124.718 71.5278C124.718 71.5225 124.715 71.5161 124.713 71.5107L118.003 73.1934Z",
    fill: "#EDDD9A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M118.529 73.0612C118.529 73.0666 118.53 73.0729 118.532 73.0772L118.962 74.7886C119.354 76.3499 120.938 77.2988 122.501 76.9069C124.066 76.515 125.013 74.9303 124.622 73.3679L124.19 71.6576C124.19 71.6533 124.188 71.6469 124.186 71.6416L118.529 73.0612Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 6.91789,
    height: 2.03649,
    transform: "matrix(-0.969933 0.243371 0.24351 0.969898 124.712 71.5107)",
    fill: "#E66D28"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M80.868 76.3514V76.3717L80.7465 78.6923C80.6379 80.8105 78.8311 82.44 76.7111 82.3292C74.5901 82.2195 72.9634 80.4133 73.0731 78.295L73.1935 75.9744V75.9531L80.868 76.3514Z",
    fill: "#EDDD9A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.267 76.3198V76.338L80.1658 78.2933C80.0721 80.0803 78.5487 81.4531 76.7611 81.3604C74.9746 81.2678 73.5993 79.7438 73.693 77.9578L73.7942 76.0014C73.7942 75.9961 73.7942 75.9897 73.7963 75.9844L80.267 76.3198Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 7.68299,
    height: 2.26423,
    transform: "matrix(0.998656 0.0518301 0.0518616 -0.998654 73.0762 78.2129)",
    fill: "#E66D28"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1084 75.7981V75.8141L71.9113 77.485C71.7313 79.0101 70.3485 80.1017 68.824 79.9228C67.2953 79.7439 66.2055 78.3604 66.3845 76.8343L66.5805 75.1633C66.5805 75.158 66.5826 75.1538 66.5837 75.1484L72.1084 75.7981Z",
    fill: "#EDDD9A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6754 75.7467V75.7595L71.5092 77.1685C71.3568 78.455 70.1924 79.3762 68.9045 79.2239C67.6176 79.0737 66.6972 77.9076 66.8495 76.62L67.0136 75.2121C67.0146 75.2078 67.0146 75.2025 67.0167 75.1982L71.6754 75.7467Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 5.56405,
    height: 1.63912,
    transform: "matrix(0.99314 0.116928 0.116999 -0.993132 66.3907 76.7754)",
    fill: "#E66D28"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M65.993 75.1904C65.9919 75.1968 65.9919 75.2053 65.9898 75.2117L65.5946 77.6463C65.2345 79.87 63.139 81.3791 60.9146 81.018C58.6913 80.657 57.1818 78.5633 57.5419 76.3396L57.9382 73.9061C57.9382 73.8986 57.9403 73.8922 57.9424 73.8848L65.993 75.1904Z",
    fill: "#EDDD9A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3605 75.0875C65.3605 75.0929 65.3583 75.0992 65.3583 75.1046L65.0249 77.1579C64.7202 79.0322 62.955 80.306 61.0779 80.0014C59.204 79.6979 57.9299 77.931 58.2346 76.0567L58.568 74.0034C58.5702 73.998 58.5712 73.9927 58.5712 73.9863L65.3605 75.0875Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 8.15799,
    height: 2.40175,
    transform: "matrix(0.987112 0.160031 0.160125 -0.987097 57.5557 76.2539)",
    fill: "#E66D28"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5259 72.9208C53.5259 72.925 53.5259 72.9282 53.5237 72.9325L53.1509 74.3393C52.81 75.6237 51.4932 76.3884 50.2074 76.0476C48.9237 75.7068 48.1588 74.3894 48.4986 73.1061L48.8704 71.7003C48.8726 71.696 48.8747 71.6907 48.8747 71.6875L53.5259 72.9208Z",
    fill: "#EDDD9A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1635 72.8226C53.1614 72.8269 53.1614 72.8301 53.1592 72.8343L52.845 74.0207C52.5584 75.1028 51.4473 75.7471 50.3639 75.4606C49.2815 75.1731 48.6359 74.0633 48.9225 72.9792L49.2378 71.7928C49.2378 71.7907 49.2399 71.7875 49.2421 71.7832L53.1635 72.8226Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 4.81182,
    height: 1.41553,
    transform: "matrix(0.966599 0.256294 0.25644 -0.96656 48.5117 73.0557)",
    fill: "#E66D28"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.769 109.923C115.769 118.541 102.795 125.527 86.7905 125.527C70.7884 125.527 57.814 118.541 57.814 109.923C57.814 101.306 70.7884 94.3203 86.7905 94.3203C102.795 94.3203 115.769 101.306 115.769 109.923Z",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.5554,
    cy: 52.8195,
    rx: 36.655,
    ry: 27.8195,
    fill: "url(#paint7_linear_14011_164659)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M81.007 30.0973L86.0492 26.1761C86.0492 26.1761 81.7819 12.4698 74.0057 10.699C82.0982 17.6692 81.007 30.0973 81.007 30.0973Z",
    fill: "url(#paint8_linear_14011_164659)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5816 12.9833C71.656 16.9051 73.4564 27.2313 73.4564 27.2313L76.7005 22.9533C76.7005 22.9533 70.432 12.9768 63.8197 12.9819C63.7413 12.977 63.6644 12.9823 63.5816 12.9833Z",
    fill: "url(#paint9_linear_14011_164659)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6896 21.4007C64.3631 22.009 68.3312 28.7446 68.3312 28.7446L69.4739 24.9072C69.4739 24.9072 64.3009 20.9856 59.9192 20.9859C59.1401 20.9855 58.3857 21.111 57.6896 21.4007Z",
    fill: "url(#paint10_linear_14011_164659)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2902 30.9849L62.1124 29.0601C62.1124 29.0601 59.5072 23.7107 56.2064 23.4722C59.9608 25.8261 60.2902 30.9849 60.2902 30.9849Z",
    fill: "url(#paint11_linear_14011_164659)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1323 28.8902C56.2137 29.2106 58.0119 32.351 58.0119 32.351L58.5633 30.5825C58.5633 30.5825 56.1596 28.7112 54.1219 28.7109C53.7782 28.7113 53.4419 28.7638 53.1323 28.8902Z",
    fill: "url(#paint12_linear_14011_164659)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8696 31.0574C54.8905 31.8933 55.4747 34.3769 55.4747 34.3769L56.2026 33.2915C56.2026 33.2915 54.5994 31.0496 53.0234 31.0499C52.9725 31.0498 52.9205 31.0511 52.8696 31.0574Z",
    fill: "url(#paint13_linear_14011_164659)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9787 23.5452L93.3498 26.5754C93.3498 26.5754 90.5379 14.8758 97.2823 7.0654C90.1112 9.85113 87.9787 23.5452 87.9787 23.5452Z",
    fill: "url(#paint14_linear_14011_164659)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7714 23.0871L97.0179 25.7638C97.0179 25.7638 97.8677 18.9949 103.001 16.2032C98.6416 16.2482 94.7714 23.0871 94.7714 23.0871Z",
    fill: "url(#paint15_linear_14011_164659)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M104.366 25.2428L105.829 27.5532C105.829 27.5532 107.192 22.3868 111.47 20.753C111.328 20.7373 111.186 20.7267 111.046 20.7275C107.779 20.7278 104.366 25.2428 104.366 25.2428Z",
    fill: "url(#paint16_linear_14011_164659)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M114.876 32.9767L116.274 34.3352C116.274 34.3352 116.358 30.53 119.048 28.6843C116.629 28.9612 114.876 32.9767 114.876 32.9767Z",
    fill: "url(#paint17_linear_14011_164659)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9797 25.2759L101.378 26.6347C101.378 26.6347 101.46 22.8304 104.149 20.9862C101.734 21.2594 99.9797 25.2759 99.9797 25.2759Z",
    fill: "url(#paint18_linear_14011_164659)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M117.786 34.1182L118.264 35.2328C118.264 35.2328 119.224 33.066 121.209 32.6471C121.064 32.6055 120.913 32.5864 120.759 32.5862C119.381 32.5863 117.786 34.1182 117.786 34.1182Z",
    fill: "url(#paint19_linear_14011_164659)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M109.454 29.7836L110.712 32.7124C110.712 32.7124 113.231 27.0126 118.455 25.9159C118.071 25.8085 117.674 25.7583 117.27 25.758C113.645 25.7557 109.454 29.7836 109.454 29.7836Z",
    fill: "url(#paint20_linear_14011_164659)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14011_164659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.325 76.9303) scale(43.325 28.9222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14011_164659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.296 55.8595) scale(12.3464 12.3427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14011_164659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.295 55.8599) scale(6.64141 6.63939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14011_164659",
    x1: 101.307,
    y1: 49.74,
    x2: 101.307,
    y2: 52.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_14011_164659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.88 55.4195) scale(12.3464 12.3427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_14011_164659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.8798 55.4201) scale(6.64242 6.64039)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14011_164659",
    x1: 71.8869,
    y1: 49.2998,
    x2: 71.8869,
    y2: 52.0839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14011_164659",
    x1: 86.6222,
    y1: 25,
    x2: 86.6222,
    y2: 36.6565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14011_164659",
    x1: 87.8207,
    y1: 24.7982,
    x2: 81.0084,
    y2: 30.0992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14011_164659",
    x1: 77.8466,
    y1: 21.4549,
    x2: 73.4565,
    y2: 27.2315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14011_164659",
    x1: 69.8753,
    y1: 23.559,
    x2: 68.3321,
    y2: 28.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14011_164659",
    x1: 62.7534,
    y1: 28.3846,
    x2: 60.2918,
    y2: 30.9864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14011_164659",
    x1: 58.7569,
    y1: 29.9611,
    x2: 58.0121,
    y2: 32.3511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14011_164659",
    x1: 56.4582,
    y1: 32.9101,
    x2: 55.4749,
    y2: 34.3771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14011_164659",
    x1: 86.0899,
    y1: 22.4834,
    x2: 93.3469,
    y2: 26.5804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14011_164659",
    x1: 93.9841,
    y1: 22.145,
    x2: 97.0139,
    y2: 25.7671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_14011_164659",
    x1: 103.851,
    y1: 24.4302,
    x2: 105.829,
    y2: 27.5572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_14011_164659",
    x1: 114.384,
    y1: 32.4999,
    x2: 116.273,
    y2: 34.3363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_14011_164659",
    x1: 99.4877,
    y1: 24.799,
    x2: 101.377,
    y2: 26.6358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_14011_164659",
    x1: 117.617,
    y1: 33.7248,
    x2: 118.264,
    y2: 35.2331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_14011_164659",
    x1: 109.008,
    y1: 28.7503,
    x2: 110.71,
    y2: 32.7139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterHandsUp1);
export default __webpack_public_path__ + "static/media/MonsterHandsUp1.043c50a4b7bd5967fa422111db0f515a.svg";
export { ForwardRef as ReactComponent };